import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { LocationsTab } from './components/LocationsTab';
import { ManufacturersTab } from './components/ManufacturersTab';
import { UsersTab } from './components/UsersTab';
import { PerLocationSettingsTab } from './components/PerLocationSettingsTab';
import { NotificationsTab } from './components/NotificationsTab';
import { FeatureFlagsTab } from './components/FeatureFlagsTab';

export function AdminPage() {
  const { user, isLoading } = useAuthStore();
  const [activeTab, setActiveTab] = useState<string>('locations');

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  // Redirect non-admin users to dashboard
  if (!user?.is_admin) {
    return <Navigate to="/" replace />;
  }

  const tabs = [
    { id: 'locations', label: 'Locations' },
    { id: 'manufacturers', label: 'Manufacturers' },
    { id: 'users', label: 'Users & Roles' },
    { id: 'settings', label: 'Per-Location Settings' },
    { id: 'notifications', label: 'Notifications' },
    { id: 'features', label: 'Feature Flags & Reports' },
  ];

  return (
    <div className="p-4 sm:p-6">
      <h1 className="text-2xl sm:text-3xl font-bold mb-6">Admin</h1>

      {/* Tab Navigation */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap
                ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="bg-white rounded-lg shadow p-6">
        {activeTab === 'locations' && <LocationsTab />}
        {activeTab === 'manufacturers' && <ManufacturersTab />}
        {activeTab === 'users' && <UsersTab />}
        {activeTab === 'settings' && <PerLocationSettingsTab />}
        {activeTab === 'notifications' && <NotificationsTab />}
        {activeTab === 'features' && <FeatureFlagsTab />}
      </div>
    </div>
  );
}
